import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconLoading = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12.75 5C12.75 4.58579 12.4142 4.25 12 4.25C11.5858 4.25 11.25 4.58579 11.25 5V6.75C11.25 7.16421 11.5858 7.5 12 7.5C12.4142 7.5 12.75 7.16421 12.75 6.75V5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.58034 6.51966C7.28745 6.22677 6.81257 6.22676 6.51968 6.51965C6.22678 6.81254 6.22678 7.28742 6.51967 7.58031L7.75967 8.82033C8.05256 9.11323 8.52743 9.11323 8.82033 8.82034C9.11322 8.52745 9.11323 8.05258 8.82034 7.75968L7.58034 6.51966Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.25 12C4.25 11.5858 4.58579 11.25 5 11.25H6.75C7.16421 11.25 7.5 11.5858 7.5 12C7.5 12.4142 7.16421 12.75 6.75 12.75H5C4.58579 12.75 4.25 12.4142 4.25 12Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.82034 16.2403C9.11323 15.9474 9.11322 15.4725 8.82033 15.1796C8.52743 14.8867 8.05256 14.8867 7.75967 15.1796L6.51967 16.4197C6.22678 16.7126 6.22678 17.1874 6.51968 17.4803C6.81257 17.7732 7.28745 17.7732 7.58034 17.4803L8.82034 16.2403Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 16.5C12.4142 16.5 12.75 16.8358 12.75 17.25V19C12.75 19.4142 12.4142 19.75 12 19.75C11.5858 19.75 11.25 19.4142 11.25 19V17.25C11.25 16.8358 11.5858 16.5 12 16.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.2403 15.1796C15.9474 14.8867 15.4726 14.8867 15.1797 15.1796C14.8868 15.4725 14.8868 15.9474 15.1797 16.2403L16.4197 17.4803C16.7125 17.7732 17.1874 17.7732 17.4803 17.4803C17.7732 17.1874 17.7732 16.7126 17.4803 16.4197L16.2403 15.1796Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.5 12C16.5 11.5858 16.8358 11.25 17.25 11.25H19C19.4142 11.25 19.75 11.5858 19.75 12C19.75 12.4142 19.4142 12.75 19 12.75H17.25C16.8358 12.75 16.5 12.4142 16.5 12Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.4803 7.58031C17.7732 7.28742 17.7732 6.81254 17.4803 6.51965C17.1874 6.22676 16.7125 6.22677 16.4197 6.51966L15.1797 7.75968C14.8868 8.05258 14.8868 8.52745 15.1797 8.82034C15.4726 9.11323 15.9474 9.11323 16.2403 8.82033L17.4803 7.58031Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconLoading as ReactComponent };
